Number.prototype.globalRoundTo = function(num) {
  const resto = (this + 0.00001)%num;
  if (resto <= (num/2)) {
    return Math.abs(this -resto).toFixed(0);
  } else {
    return Math.abs(this+num-resto).toFixed(0);
  }
}
